import React from 'react';
import customizableComponent from '../../../core/hocs/customization';
import useKeyboard from '../../../core/hooks/useKeyboard';
import { Container, Frame, Counter, LeftButton, RightButton, CloseButton, ImageRenderer, } from './styles';
const ImageGallery = ({ index = 0, items = [], children, onChange, showCounter = true }) => {
    const [render = ImageRenderer] = [].concat(children);
    const handleClose = () => onChange(null);
    const next = () => onChange(index + 1 < items.length ? index + 1 : 0);
    const prev = () => onChange(index - 1 >= 0 ? index - 1 : items.length - 1);
    const listeners = {
        ArrowLeft: prev,
        ArrowRight: next,
        Escape: handleClose,
    };
    const params = {
        ignoreOtherKeys: true,
    };
    useKeyboard(listeners, params);
    return (React.createElement(Container, { length: items.length },
        React.createElement(Frame, null, render(items[index])),
        showCounter && React.createElement(Counter, null, `${index + 1} / ${items.length}`),
        items.length > 1 && React.createElement(LeftButton, { onClick: prev }),
        items.length > 1 && React.createElement(RightButton, { onClick: next }),
        React.createElement(CloseButton, { onClick: handleClose })));
};
export default customizableComponent('ImageGallery', ImageGallery);
//# sourceMappingURL=index.js.map